<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
    >
      <div
        class="
          d-flex
          pb-6
          align-center
        "
      >
        <h2
          class="display-1"
        >Brands</h2>

        <v-spacer></v-spacer>

        <TableSearch
          label="Search brands"
          v-model="search"
          @input="doSearch"
        ></TableSearch>

        <NewButton
          to-name="new-brand"
          class="ml-6"
        >Create new brand</NewButton>
      </div>

      <v-data-table
        :headers="headers"
        :items="brands"
        :page="page"
        :items-per-page="itemsPerPage"
        :sort-by.sync="sortBy"
        @update:sort-by="updatePagination"
        :sort-desc.sync="sortDesc"
        @update:sort-desc="updatePagination"
        multi-sort
        hide-default-footer
        :loading="loading"
        @page-count="pageCount = $event"
        @click:row="goToBrand"
      >
        <template v-slot:item.updated_at="{ item }">
          <span
            class="text-no-wrap"
            :id="`focus_${item.id}`"
          >
            {{ new Date(item.updated_at).toLocaleDateString() }}
          </span>
        </template>

        <template v-slot:item.created_at="{ item }">
          <span class="text-no-wrap">
            {{ new Date(item.created_at).toLocaleDateString() }}
          </span>
        </template>

        <template v-slot:item.uri="{ item }">
          {{ item.uri }}
          <v-tooltip
            top
            v-if="item.status === 'displayed'"
          >
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-2"
                v-on="on"
                @click.stop="goToFront(`nos-marques/${item.uri}`)"
              >input</v-icon>
            </template>

            <span>View brand</span>
          </v-tooltip>

          <v-tooltip
            top
            v-if="item.ebuyclub_partner_id"
          >
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-2"
                v-on="on"
                @click.stop="goToFront(`bons-plans/${item.uri}`)"
              >input</v-icon>
            </template>

            <span>View deals</span>
          </v-tooltip>
        </template>

        <template v-slot:item.status="{ item }">
          <span
            class="font-weight-medium"
            :class="{
              'red--text': item.status === 'hidden',
              'green--text': item.status === 'displayed'
            }"
          >{{ $translate.instant('BRAND_' + item.status.toUpperCase()) }}</span>
        </template>
      </v-data-table>

      <div
        class="py-6"
      >
        <TablePagination
          v-model="page"
          @input="updatePagination"
          :itemsPerPage.sync="itemsPerPage"
          @update:itemsPerPage="updatePagination"
          :pageCount.sync="pageCount"
          :total="brands.length"
        ></TablePagination>
      </div>
    </v-container>
  </ApplicationLayout>
</template>

<script>
import { mapState } from 'vuex'
import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import TableSearch from '../components/TableSearch.vue'
import NewButton from '../components/NewButton.vue'
import TablePagination from '../components/TablePagination.vue'

export default {
  components: {
    ApplicationLayout,
    TableSearch,
    NewButton,
    TablePagination
  },
  data() {
    const { itemsPerPage, sortBy, sortDesc, search } = this.$pagination.getOptions('brands')
    return {
      search,
      pageCount: 0,
      page: 1,
      loading: true,
      itemsPerPage,
      sortBy,
      sortDesc,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'URI', value: 'uri' },
        { text: 'Status', value: 'status' },
        { text: 'Last update', value: 'updated_at' },
        { text: 'Creation date', value: 'created_at' }
      ]
    }
  },
  computed: {
    ...mapState('Brands', ['brands'])
  },
  async created() {
    await this.$store.dispatch('Brands/getAll', { search: this.search })
    const { page } = this.$pagination.getOptions('brands')
    this.page = page
    this.$pagination.focus()
    this.updatePagination()
    this.loading = false
  },
  methods: {
    updatePagination() {
      this.$pagination.update({
        itemsPerPage: this.itemsPerPage,
        page: this.page,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        search: this.search
      }, 'brands')
    },
    goToBrand(brand) {
      this.$router.push({
        name: 'brand',
        params: { id: brand.id }
      })
    },
    goToFront(uri) {
      window.open(`${process.env.VUE_APP_FRONT_URL}${uri}.html`, '_blank')
    },
    async doSearch() {
      this.page = 1
      this.loading = true
      await this.$store.dispatch('Brands/getAll', { search: this.search })
      this.loading = false
      this.updatePagination()
    }
  }
}
</script>
